var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8Email(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.215,
    height: 11.372,
    viewBox: "0 0 14.215 11.372",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #e4e4e4;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8_new_post_1",
    className: "cls-1",
    d: "M6.31,8A2.318,2.318,0,0,0,4,10.31v6.752a2.318,2.318,0,0,0,2.31,2.31H15.9a2.318,2.318,0,0,0,2.31-2.31V10.31A2.318,2.318,0,0,0,15.9,8Zm0,1.066H15.9a1.236,1.236,0,0,1,1.244,1.244V10.7l-6.041,3.266L5.066,10.7V10.31A1.236,1.236,0,0,1,6.31,9.066ZM5.066,11.915l5.788,3.129a.533.533,0,0,0,.507,0l5.788-3.129v5.147A1.236,1.236,0,0,1,15.9,18.306H6.31a1.236,1.236,0,0,1-1.244-1.244Z",
    transform: "translate(-4 -8)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Email);
export default __webpack_public_path__ + "static/media/icons8_email.80763fefee9c464057d2d231b81dc64d.svg";
export { ForwardRef as ReactComponent };